<template>
  <div class="payrate">
    <!-- <Sidebar /> -->
    
    <div
      class="py-5"
      :class="{'bg_i6_tp': isThaiCharoenPlus, 'bg_i6_sc': isSevenColor, 'bg_i6_ts': isThaisiam, 'bg_i6_hp': isHuaypromt, 'bg_i6_jj': isJertjarat, 'bg_i6_ls': isLottoslot88, 'bg_i6_cc': isChokCharoen, 'bg_i6_bc': isBooncharern, 'bg_i6': isDefaultSite}"
    >
      <div class="container">
        <div class="row">
          <div class="col-12 mb-5">
            <router-link
              :to="{ name: R.ROUTE_INDEX }"
            > 
              <a
                class="txt-link bdr-20 animateMe animated fadeInDown theme-main-text"
                data-animation="fadeInDown"
              >
                <i
                  class="fas fa-chevron-left me-2 theme-main-text"
                ></i>
                <span
                  class="theme-main-text"
                >ย้อนกลับ</span>
              </a>
            </router-link>
          </div>
          <div class="col-12 mb-5">
            <h2
              class="t-semibold text-center animateMe animated fadeInUp theme-main-text"
              data-animation="fadeInUp"
            >
              อัตราจ่าย
            </h2>
          </div>

          <div
            v-for="(item) in items"
            :key="item.id"
            class="col-12 col-md-6 col-lg-4 mb-4 animateMe animated fadeInUp"
            data-animation="fadeInUp"
          >
            <div class="bg_c9 bdr-10 h-100">
              <div class="table-responsive">
                <table class="table table-bg table-hover mb-0">
                  <thead>
                    <tr class="t-medium c-white">
                      <th
                        scope="col"
                        colspan="2"
                      >
                        {{ item.game_type.name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="t-medium">
                      <th scope="col">
                        ประเภท
                      </th>
                      <th
                        scope="col"
                        class="text-end"
                      >
                        บาทละ
                      </th>
                    </tr>
                    <tr 
                      v-for="(price) in item.price"
                      :key="price.number_type_id"
                    >
                      <td>{{ price.number_type_name }}</td>
                      <td class="text-end">
                        {{ price.reward }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div 
            v-if="!onLoading"
            class="col-12 col-md-4 offset-md-4 mt-5"
          >
            <router-link
              :to="{ name: R.ROUTE_INDEX }"
            > 
              <a
                class="button-main bdr-20 bg_c4 c-white mb-3 animateMe animated fadeInUp"
                data-animation="fadeInUp"
              >
                เข้าสู่หน้าหลัก
              </a>
            </router-link>

            <router-link
              :to="{ name: R.ROUTE_V3_REGISTER }"
            > 
              <a
                class="button-main bdr-20 bg_c3 c-white mb-3 animateMe animated fadeInUp"
                :class="{'bg_c3_bc': isBooncharern}"
                data-animation="fadeInUp"
              >
                สมัครสมาชิก
              </a>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as R from '@/const/route'
import { anonymous as apiAnonymous } from '@/apis' 
// import Sidebar from '@/components/Sidebar/Sidebar' 

export default {
  components: {
    // Sidebar,
  },
  data () {
    return {
      onLoading: true,
      items: []
    }
  },
  computed: {
    R: () => R,
  },
  mounted () {
    window.scrollTo(0, 0);
    this.init()
  },
  methods: {
    async init () {
      const [err, data] = await apiAnonymous.getPricing({})

      if (err) {
        this.onLoading = false
        return
      }

      this.items = data
      this.onLoading = false
    }
  }
}
</script>

<style scoped>
.container {
  min-height: 100vh;
}

.payrate {
  width: 100%;
}

.bg_c3_bc {
  background: linear-gradient(90deg, var(--v3-btn-login-color-20) 0%, var( --v3-btn-login-color-20-end) 100%) !important;
}
</style>
